const parseParams = (query) =>
  query.split('&').reduce((obj, item) => {
    const arr = item.split('=');
    obj[arr[0]] = decodeURIComponent(arr[1]);
    return obj;
  }, {});

/**
 * 从指定链接中获取路由
 * @param {string | Location} location
 * @returns {import('vue-router').Route}
 */
const getRoute = (location = window.location) => {
  /**
   * @type {import('vue-router').Route}
   */
  const route = {};

  let hash;
  let search;
  if (typeof location === 'string') {
    hash = location.slice(location.indexOf('#'));
    search = location.slice(location.indexOf('?'), location.indexOf('#'));
  } else {
    hash = location.hash;
    search = location.search;
  }

  // path
  const queryIndex = hash.indexOf('?');
  if (queryIndex > -1) {
    route.path = hash.slice(1, queryIndex);
  } else {
    route.path = hash.length > 0 ? hash.slice(1) : '';
  }
  route.path = route.path || '/';

  // hash
  route.hash = hash;

  // params
  route.params = {};
  if (search) {
    const searchParams = parseParams(search.slice(1));
    route.params = Object.assign(route.params, searchParams);
  }
  if (queryIndex > -1) {
    const queryQarams = parseParams(hash.slice(queryIndex + 1));
    route.params = Object.assign(route.params, queryQarams);
  }
  // query
  route.query = { ...route.params };

  route.fullPath = hash.length > 0 ? hash.slice(1) : '';

  route.matched = [];

  return route;
};

export default getRoute;
